import { appReducer } from 'store/slices/app';
import { bannersReducer } from 'store/slices/banners';
import { collectionReducer } from 'store/slices/collection';
import { commentsReducer } from 'store/slices/comments';
import { endCustomerReducer } from 'store/slices/endCustomer';
import { imageReducer } from 'store/slices/image';
import { imagesReducer } from 'store/slices/images';
import { modalsReducer } from 'store/slices/modals';
import { reactionsReducer } from 'store/slices/reactions';
import { selectionReducer } from 'store/slices/selection';
import { sharingReducer } from 'store/slices/sharing';
import { userBrandReducer } from 'store/slices/userBrand';
import { messagesReducer } from './slices/messages';
import { portfolioReducer } from './slices/portfolios';
import { photobookReducer } from 'modules/ScrPhotobook/store/slices/photobook';
import { drawersReducer } from './slices/drawers';
import { scrAppBookNewReducer } from 'modules/ScrAppBookNew/store';

export const reducers = {
  collection: collectionReducer,
  modals: modalsReducer,
  drawers: drawersReducer,
  images: imagesReducer,
  scrAppBookNew: scrAppBookNewReducer,
  userBrand: userBrandReducer,
  sharing: sharingReducer,
  selection: selectionReducer,
  endCustomer: endCustomerReducer,
  banners: bannersReducer,
  image: imageReducer,
  comments: commentsReducer,
  reactions: reactionsReducer,
  app: appReducer,
  messages: messagesReducer,
  portfolio: portfolioReducer,
  photobook: photobookReducer
};
